import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TimelineMax } from 'gsap'

import ShareButton from './ShareButton'
import SlideHOC from '../SlideHOC'
import ANIMATION_TYPES from '../../../../constants/animationTypes'
import EmailIcon from '../../assets/email.svg'

import './LastScene.scss'
const BOUNCE_PERCENT = 1

class LastScene extends Component {

  defineAnimations () {
    this.inAnimation = new TimelineMax({ paused: true })
    .fromTo(this.bgRef, 0.05, { xPercent: 0, autoAlpha: 0 }, { xPercent: 100, autoAlpha: 1 })
    .to(this.rootRef, 0, { autoAlpha: 1, zIndex: 10, xPercent: 0, immediateRender: false })
    .to(this.wrapperRef, 0, { xPercent: 0, rotationY: 0, immediateRender: false })
    .fromTo(this.bgRef, this.props.duration,
    { xPercent: 100 }, { xPercent: -BOUNCE_PERCENT, delay: this.props.duration * 0.05 })
    .fromTo(this.bgRef, this.props.duration * 0.2,
    { xPercent: -BOUNCE_PERCENT }, { xPercent: BOUNCE_PERCENT })
    .to(this.bgRef, this.props.duration * 0.2, { xPercent: 0 })
    .fromTo(this.contentRef, this.props.duration * 0.5,
    { xPercent: 150, autoAlpha: 0 }, { autoAlpha: 1, xPercent: -3, delay: this.props.duration * 0.5, immediateRender: false }, 0)
    .fromTo(this.contentRef, this.props.duration * 0.5,
    { xPercent: -3 }, { xPercent: 1.5, delay: this.props.duration * 0.5 * 2 }, 0)
    .to(this.contentRef, this.props.duration * 0.5,
    { xPercent: 0, delay: this.props.duration * 0.5 * 3 }, 0)
    .fromTo(this.shareButtonRef, this.props.duration,
    { autoAlpha: 0 }, { autoAlpha: 1, delay: this.props.duration * 0.5, immediateRender: false }, 0)


    this.inReversedAnimation = this.inAnimation

    this.outReversedAnimation = new TimelineMax({ paused: true })
    .fromTo(this.rootRef, this.props.duration,
    { zIndex: 1, xPercent: 0, autoAlpha: 1, immediateRender: false }, { xPercent: 0, autoAlpha: 0 })
    .fromTo(this.wrapperRef, this.props.duration,
    { rotationY: 0, xPercent: 0 }, { xPercent: 0, rotationY: -100, transformOrigin: 'right' }, 0)

    this.outAnimation = this.outReversedAnimation
  }

  onClick = () => {
    if (this.props.buttonUrl) {
      window.location.href = this.props.buttonUrl
    }
  }

  renderOptionalSection = () => {
    let { button, optionalBlockType, signUpButton } = this.props

    if (signUpButton === '') {
      signUpButton = 'Sign up'
    }

    switch (optionalBlockType) {
      case 'email':
        return (
          <div>
            <div className='bo_last__signup'>
              <img src={EmailIcon} alt='email' className='bo_last__signup--icon' />
              <input type='email' className='bo_last__signup--field' placeholder='Enter you email here' />
            </div>
            <div id='bo_last__signup--button' className='bo_last__signup--button'>{ signUpButton }</div>
          </div>
        )
      case 'button':
      default:
        return (
          <div id='bo_last__button' className='bo_last__button' onClick={this.onClick}>{ button }</div>
        )
    }
  }

  render () {
    const { title, description, bg, facebook, twitter, email, phone, shareTitle, shareSubtitle } = this.props
    return (
      <div className='bo_last' ref={ref => (this.rootRef = ref)}>
        <div className='bo_last__wrapper' ref={ref => (this.wrapperRef = ref)}>
          <div
            id='bo_last__bg'
            className='bo_last__bg'
            style={{ backgroundImage: `url(${bg})` }}
            ref={ref => (this.bgRef = ref)}
          />

          <div className='bo_last__content' ref={ref => (this.contentRef = ref)}>
            <div id='bo_last__title' className='bo_last__title'>
              <span className='bo_last__title--text'>{ title }</span>
            </div>
            <div className='bo_last__divider' />
            <div id='bo_last__description' className='bo_last__description'>
              <span className='bo_last__description--text'>{ description }</span>
            </div>
            <div id='bo_last__optional-block' className='co_last__optional-block'>
              { this.renderOptionalSection() }
            </div>
          </div>
          <div className='bo_last__share-container' ref={ref => (this.shareButtonRef = ref)}>
            <ShareButton setShareButtonsVisible={this.props.setShareButtonsVisible} shareTitle={shareTitle} shareSubtitle={shareSubtitle} facebook={facebook} twitter={twitter} email={email} phone={phone} />
          </div>
        </div>
      </div>
    )
  }

  static defaultProps = {
    animation: ANIMATION_TYPES.NONE,
    duration: 0.5
  }

  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    bg: PropTypes.string,
    button: PropTypes.string,
    buttonUrl: PropTypes.string,
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // eslint-disable-line react/no-unused-prop-types
    duration: PropTypes.number,
    shareTitle: PropTypes.string,
    shareSubtitle: PropTypes.string,
    optionalBlockType: PropTypes.string,
    signUpButton: PropTypes.string,
    setShareButtonsVisible: PropTypes.func
  }
}

export default SlideHOC(LastScene)



// WEBPACK FOOTER //
// ./src/templates/bouncy/components/last/LastScene.js